import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Spinner } from 'react-bootstrap';
import api from '../api';
import { toast } from 'react-toastify';

export default function SettingsPage() {
  const [settings, setSettings] = useState({
    startButtonIconUrl: '',
    stopButtonIconUrl: '',
    debitButtonIconUrl: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/api/admin/settings');
        const s = res.data || {};
        setSettings({
          startButtonIconUrl: s.startButtonIconUrl || '',
          stopButtonIconUrl: s.stopButtonIconUrl || '',
          debitButtonIconUrl: s.debitButtonIconUrl || ''
        });
      } catch (err) {
        toast.error('获取系统设置失败');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      for (const key of ['startButtonIconUrl', 'stopButtonIconUrl', 'debitButtonIconUrl']) {
        await api.put('/api/admin/settings', { key, value: settings[key] });
      }
      toast.success('保存成功');
    } catch (err) {
      toast.error('保存失败');
    } finally {
      setSaving(false);
    }
  };

  // 上传图标
  const uploadIcon = async (e, key) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('icon', file);
    formData.append('key', key);
    try {
      const res = await api.post('/api/admin/settings/icon', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      const { iconUrl } = res.data;
      setSettings(prev => ({ ...prev, [key]: iconUrl }));
      toast.success('上传成功');
    } catch (err) {
      console.error('上传失败:', err);
      toast.error('上传失败');
    }
  };

  if (loading) return <Container className="mt-4 text-center"><Spinner animation="border"/></Container>;

  return (
    <Container className="mt-4">
      <h4>自定义控制按钮图标</h4>
      <Form>
        <Form.Group controlId="startIcon" className="mb-3">
          <Form.Label>启动按钮图标 URL</Form.Label>
          <div className="d-flex align-items-center">
            <Form.Control
              type="file"
              accept="image/*"
              onChange={e => uploadIcon(e, 'startButtonIconUrl')}
            />
            {settings.startButtonIconUrl && (() => {
              const url = settings.startButtonIconUrl.startsWith('http')
                ? settings.startButtonIconUrl
                : api.defaults.baseURL + settings.startButtonIconUrl;
              return <img src={url} alt="start" style={{ width:48, height:48, marginLeft:12 }} />;
            })()}
          </div>
        </Form.Group>
        <Form.Group controlId="stopIcon" className="mb-3">
          <Form.Label>停止按钮图标 URL</Form.Label>
          <div className="d-flex align-items-center">
            <Form.Control
              type="file"
              accept="image/*"
              onChange={e => uploadIcon(e, 'stopButtonIconUrl')}
            />
            {settings.stopButtonIconUrl && (() => {
              const url = settings.stopButtonIconUrl.startsWith('http')
                ? settings.stopButtonIconUrl
                : api.defaults.baseURL + settings.stopButtonIconUrl;
              return <img src={url} alt="stop" style={{ width:48, height:48, marginLeft:12 }} />;
            })()}
          </div>
        </Form.Group>
        <Form.Group controlId="debitIcon" className="mb-3">
          <Form.Label>下分按钮图标 URL</Form.Label>
          <div className="d-flex align-items-center">
            <Form.Control
              type="file"
              accept="image/*"
              onChange={e => uploadIcon(e, 'debitButtonIconUrl')}
            />
            {settings.debitButtonIconUrl && (() => {
              const url = settings.debitButtonIconUrl.startsWith('http')
                ? settings.debitButtonIconUrl
                : api.defaults.baseURL + settings.debitButtonIconUrl;
              return <img src={url} alt="debit" style={{ width:48, height:48, marginLeft:12 }} />;
            })()}
          </div>
        </Form.Group>

        <Form.Group controlId="startIconUrl" className="mb-3">
          <Form.Label>或手动填写 URL</Form.Label>
          <Form.Control
            type="text"
            name="startButtonIconUrl"
            value={settings.startButtonIconUrl}
            onChange={handleChange}
            placeholder="请输入图片 URL"
          />
        </Form.Group>
        <Form.Group controlId="stopIconUrl" className="mb-3">
          <Form.Label>或手动填写 URL</Form.Label>
          <Form.Control
            type="text"
            name="stopButtonIconUrl"
            value={settings.stopButtonIconUrl}
            onChange={handleChange}
            placeholder="请输入图片 URL"
          />
        </Form.Group>
        <Form.Group controlId="debitIconUrl" className="mb-3">
          <Form.Label>或手动填写 URL</Form.Label>
          <Form.Control
            type="text"
            name="debitButtonIconUrl"
            value={settings.debitButtonIconUrl}
            onChange={handleChange}
            placeholder="请输入图片 URL"
          />
        </Form.Group>

        <Button onClick={handleSave} disabled={saving} variant="primary">
          {saving ? '保存中...' : '保存'}
        </Button>
      </Form>
    </Container>
  );
}
